import { useMemo } from 'react';

export function useWarehouseOptions(warehouses = [], idProperty = 'id') {
  return useMemo(() => {
    return warehouses.map((warehouse) => ({
      key: warehouse[idProperty],
      text: warehouse.warehouse,
      value: warehouse[idProperty],
    }));
  }, [idProperty, warehouses]);
}
